import {atom} from 'jotai'
// import { atomWithStorage } from 'jotai/utils';

import {ProviderDetail, ProviderTab} from '../domain'

export const providerDetailAtom = atom<ProviderDetail | null>(null)
export const providerDetailTabAtom = atom<ProviderTab | null>(null)

// export const tabNameAtom = atomWithStorage<'Overview' | 'Segment' | 'Address' | 'Consent' | 'Transaction' | 'Engagement' | 'SmsEngagement' | 'PushEngagement' | 'EmailEngagement'>("MemberTab", "Overview");
export const tabNameAtom = atom<
  | 'Overview'
  | 'Segment'
  | 'Address'
  | 'Consent'
  | 'Transaction'
  | 'Engagement'
  | 'SmsEngagement'
  | 'PushEngagement'
  | 'EmailEngagement'
>('Overview')
